import React from 'react';

const HuaweiCloudLogo = () => (
    <img 
        src="https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/wangxue/header/logo.svg" 
        alt="华为云" 
        style={{ width: '160px', height: 'auto' }}
    />
);

export default HuaweiCloudLogo;